/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from 'sonner';

/**
 * This is a helper method to add toast messages to an RTK query handler.
 * It will show a loading toast when the handler is called, success on fulfillment,
 * and error on rejection.
 */
export const withToast =
  (messages: { loading: string; success: string; error: string }) =>
  <TArg>(handler: (arg: TArg, api: any) => Promise<unknown>) =>
  async (arg: TArg, api: any) => {
    const id = toast.loading(messages.loading);
    try {
      await handler(arg, api);
      toast.success(messages.success, { id });
    } catch {
      toast.error(messages.error, { id });
    }
  };
